import React, {useRef, useState, useEffect} from "react";
import ReCAPTCHA from "react-google-recaptcha";
import {observer, inject} from "mobx-react";

import {Formik, Form, useField} from 'formik';
import * as Yup from 'yup';
import {TextInput, CheckboxInput, TextArea} from "@components/Form/FormFields";


const ContactForm = ({...props}) => {

    const captchaRef = useRef();
    const thankYouRef = useRef();

    const [formAccepted, setFormAccepted] = useState(false);
    useEffect(() => {
        if (formAccepted) {
            thankYouRef.current.scrollIntoView();
        }
    }, [formAccepted])

    const onSubmitWithReCAPTCHA = async (values, {setSubmitting, resetForm}) => {
        const recaptcha = await captchaRef.current.executeAsync();

        // if (token) {
        //     setCaptchaVerified(true);
        // }

        props.berikssonStore.contactForm({...values, recaptcha}).then(res => {
            setSubmitting(false);
            setFormAccepted(true);
        }, (error) => {
            captchaRef.current.reset();
            console.log("error", error);
            setSubmitting(false);
        });
        //alert(JSON.stringify(values, null, 2));
    }


    return (
        <React.Fragment>

            {formAccepted
                ? <span ref={thankYouRef}>Tack för ditt meddelande!</span>
                :
                <Formik
                    validateOnMount={true}
                    initialValues={{
                        cultureCode: props.cultureCode,
                        nodeId: props.nodeId,
                        recaptcha: '',
                        name: '',
                        email: '',
                        message: '',
                        consent: false
                    }}
                    validationSchema={Yup.object({
                        //recaptcha: Yup.string().required(),

                        name: Yup.string()
                            .required('Måste anges'),
                        email: Yup.string()
                            .email('Ogiltig epostadress')
                            .required('Måste anges'),

                        message: Yup.string()
                            .required('Du kan inte skicka ett tomt meddelande'),

                        consent: Yup.bool().oneOf([true], 'Du måste godkänna att vi får lov att hantera dina uppgifter'),

                    })}
                    onSubmit={onSubmitWithReCAPTCHA}
                >
                    {({values, setSubmitting, isSubmitting, handleBlur, setFieldValue, isValid, touched}) => {
                        //  noValidate
                        const handleFieldBlur = (e) => {
                            // console.log("$$$$", isSubmitting);
                            // if (!values.recaptcha) {
                            //     captchaRef.current.execute();
                            //     setSubmitting(true);
                            // }
                            // handleBlur(e);
                        }

                        return <Form className={Object.keys(touched).length > 0 ? "touched" : ""}>
                            <div className={"row"}>
                                <div className={"col-12"}>
                                    <TextInput
                                        label="Namn"
                                        name="name"
                                        type="text"
                                        //onBlur={handleFieldBlur}
                                        // placeholder="F"
                                    /></div>
                                <div className={"col-12"}>
                                    <TextInput
                                        label="E-post"
                                        name="email"
                                        type="text"
                                        //onBlur={handleFieldBlur}
                                        //placeholder="Doe"
                                    />
                                </div>

                                <div className={"col-12"}>
                                    <TextArea
                                        label="Meddelande"
                                        name="message"
                                        type="text"
                                        //onBlur={handleFieldBlur}
                                        //placeholder="Doe"
                                    />
                                </div>

                                {Object.keys(touched).length > 0 && <div className={"col-12"}>
                                    <CheckboxInput
                                        id="consent"
                                        label="Medgivande"
                                        name="consent"
                                        onBlur={handleFieldBlur}
                                    >
                                        Ja, jag ger mitt medgivande till att spara och hantera den data jag angivit ovan.
                                    </CheckboxInput>
                                </div>}


                            </div>

                            <ReCAPTCHA
                                ref={captchaRef}
                                sitekey={props.recaptchaV2Key}
                                onChange={(value) => {
                                    //console.log("$$$$onChange", value);
                                    //setFieldValue("recaptcha", value);
                                    setSubmitting(false);
                                }}
                                // onExpired={(value) => {
                                //     console.log("$$$$onExpired", value);
                                //     setFieldValue("memberConsent", false);
                                // }}
                                size="invisible"
                            />
                            <div className={"row"}>
                                <div className={"col-12 "}>
                                    <button className="btn btn-success"
                                            type="submit"
                                            disabled={isSubmitting || !isValid}>Skicka
                                    </button>
                                </div>
                            </div>
                            <div className={"row"}>
                                <div className={"col-12 "}>
                                    <div className={"reCaptchaInfo"}>
                                        This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.
                                    </div>
                                </div>
                            </div>
                        </Form>
                    }
                    }
                </Formik>}
        </React.Fragment>
    );
};

@inject("store")
@observer
export default class DocTypeContactForm extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        var content = this.props.model.content;
        return (<ContactForm
            recaptchaV2Key={this.props.store.navigation.recaptchaV2Key}
            berikssonStore={this.props.store.beriksson}
            nodeId={this.props.store.navigation.NodeId}
            cultureCode={this.props.store.navigation.CultureCode}
        />);
    }
}